export default __webpack_public_path__ + "static/media/kg.58c395a6.svg";